import { Col, Input, Row, message, Button, Dropdown } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { MoreOutlined } from "@ant-design/icons";
import { DataGrid } from "@mui/x-data-grid";
import { useDebounce } from "../../../../utils/hooks";
import { AUTH_TOKEN, DOMAIN_ID, ORG_ID } from "../../../../utils/helpers";
import { CustomLoaderOverlay, CustomNoRowsOverlay } from "../../../../components/ui/common";
import { logoutHandler } from "../../../../utils/navigateHandler";
import { pamAxios } from "../../../../service/pamService";

const EndpointDetailsUser = ({ stateHostAddress }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [epmUser, setEpmUser] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hostAddress = queryParams.get("hostAddress");
  const isTabChange = queryParams.get("tab");
  // const isInstanceId = queryParams.get("instanceId");

  const [notification, setNotification] = message.useMessage();
  const [endpoint, setEndpoint] = useState([]);
  const [sortModel, setSortModel] = useState();

  //pagination
  const [paginationParams, setPaginationParams] = useState({
    current: 1,
    pageSize: 10,
  });
  const [totalCount, setTotalCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const PAGESIZE = 10;
  const [currentPageModel, setCurrentPageModel] = useState({
    pageSize: PAGESIZE,
    page: 0,
  });

  const debouncedValue = useDebounce(search, 500);
  const { instanceId } = location.state || {};

  console.log(stateHostAddress.instanceId, "instanceId");

  useEffect(() => {
    fetchEPMUsers();
  }, [debouncedValue, currentPage, paginationParams]);

  const fetchEPMUsers = () => {
    let pageDetails = {
      domainId: DOMAIN_ID(),
      pageId: currentPage + 1,
      pageSize: currentPageModel.pageSize,
      token: AUTH_TOKEN(),
      instanceIds: [Number(stateHostAddress?.instanceId || instanceId)],
      filter: {
        filterBy: "",
        value: "",
      },
      search: search,
      orgId: ORG_ID(),
    };
    setIsLoading(true);

    pamAxios
      .post(`/endpointUsers/listAllEpmUsers`, pageDetails, {
        headers: {
          withCredentials: true,
          "X-Authorization": AUTH_TOKEN(),
        },
      })
      .then((res) => {
        setIsLoading(false);

        const originalEpmUsers = res?.data?.epmUsers;

        const epmUsersWithId = (originalEpmUsers || []).map((user, index) => ({
          ...user,
          id: index + 1,
          lastActive: null,
        }));
        setEpmUser(epmUsersWithId);
        setTotalCount(res?.data?.totalCount);
        setCurrentPageModel({
          pageSize: 10,
          page: currentPage,
        });
      })
      .catch((err) => {
        setIsLoading(false);
        if (err?.response?.data?.message === "Invalid credentials" || err?.response?.status === 401) {
          logoutHandler();
        } else {
          notification.open({
            type: "error",
            content: "Unable to fetch endpoint users",
          });
        }
      });
  };

  const handleSortModelChange = (model) => {
    setSortModel(model);
  };



  const tab1columns = [
    {
      headerName: "User Name",
      field: "userName",
      key: "userName",
      flex: 1,
    },
    // {
    //   field: "epmMachineName",
    //   headerName: "Endpoints",
    //   key: "epmMachineName",
    //   flex: 1,
    //   renderCell: (val) => {
    //     const timezone = localStorage.getItem("timezone");
    //     const statusOfMachine = moment
    //       .unix(val?.row?.lastActive)
    //       .tz(timezone)
    //       .format("YYYY-MM-DD HH:mm:ss");
    //     const diff = moment().diff(statusOfMachine, "minutes");
    //     console.log(diff);

    //     return (
    //       <Tag
    //         color={
    //           val?.row?.lastActive === null
    //             ? "default"
    //             : diff > 20
    //             ? "red"
    //             : diff > 10
    //             ? "orange"
    //             : "green"
    //         }
    //         key={val?.row?.epmMachineName}
    //       >
    //         {val?.row?.epmMachineName}
    //       </Tag>
    //     );
    //   },
    // },
    // {
    //   headerName: "User Type",
    //   field: "userType",
    //   key: "userType",
    //   flex: 1,
    // },
    {
      headerName: "Action",
      key: "action",
      flex: 1,
      renderCell: (val) => (
        <Dropdown
          placement="bottomLeft"
          menu={{
            items: [
              {
                key: "view-session-recording",
                label: <Link to={`/pam/jumpServer-sessionRecordings?epmUser=${val.row.userName}`}>View Session Recordings</Link>,
              },
            ],
          }}
        >
          <Button type="text" shape="circle" icon={<MoreOutlined />} />
        </Dropdown>
      ),
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    setPaginationParams(pagination);
    console.log(isTabChange);
    if (pagination.pageSize !== paginationParams.pageSize) {
      setEndpoint([]);
    }
    fetchEPMUsers();
  };

  return (
    <>
      {setNotification}
      <Row className="content-conatiner">
        <Col span={24}>
          <Row>
            <Col span={24}>
              <Row className="search-box-container">
                <Col span={6}>
                  <p className="search-label">Search</p>
                  <div>
                    <Input
                      placeholder="Search"
                      allowClear
                      onChange={(e) => {
                        setSearch(e.target.value);
                        if (paginationParams.current !== 1) {
                          setPaginationParams({ current: 1, pageSize: 10 });
                        }
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <DataGrid
                slots={{
                  loadingOverlay: CustomLoaderOverlay,
                  noRowsOverlay: CustomNoRowsOverlay,
                  noResultsOverlay: CustomNoRowsOverlay,
                }}
                style={{ border: "none" }}
                autoHeight
                loading={isLoading}
                rows={epmUser}
                columns={tab1columns}
                paginationMode="server"
                rowCount={totalCount}
                page={currentPage}
                paginationModel={currentPageModel}
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: 10, page: 0 },
                  },
                }}
                onPaginationModelChange={(params) => {
                  setCurrentPage(params.page);
                }}
                sortModel={sortModel}
                onSortModelChange={handleSortModelChange}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default EndpointDetailsUser;
